import React from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import {motion} from 'framer-motion';
import ShopHeader from '../module/shop/Header';
import LabFooter from '../module/lab/footer';

const LabLayout = () => {
  const {pathname} = useLocation();

  return (
    <>
      <ShopHeader />
      <div className="container mb-5 pb-5">
        <motion.div
          key={pathname}
          initial={{opacity: 0, x: '100%'}}
          animate={{opacity: 1, x: 0}}
          exit={{opacity: 0, x: '-100%'}}
          transition={{duration: 0.2}}
          className="w-100 h-100 mb-5 pb-3"
        >
          <Outlet />
        </motion.div>
      </div>
      <LabFooter />
    </>
  );
};

export default LabLayout;
